import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/Next-logo-1.png")